module.exports = __webpack_public_path__ + "img/tree.10fdd152.png";